import style from './index.module.css';

const CompanyProfile = () => {

  return (
    <section className={style.section}>
      <h2 className={style.sectionTitle}>Company <span>Profile</span></h2>
      <div className={style.divider}></div>
      <div className={style.box}>
        <table>
        <tbody>
          <tr>
            <th>社名</th>
            <td>株式会社One・Achieve</td>
          </tr>
          <tr>
            <th>設立</th>
            <td>2023年（令和5年）9月20日</td>
          </tr>
          <tr>
            <th>資本金</th>
            <td>100万円</td>
          </tr>
          <tr>
            <th>事業内容</th>
            <td>
              クライアントにエンジニアの技術力や労働力を提供し<br />
              クライアントのシステム開発や保守、運用などの業務を担います。
            </td>
          </tr>
          <tr>
            <th>従業員数</th>
            <td>1名</td>
          </tr>
          <tr>
            <th>代表取締役</th>
            <td>平石 守</td>
          </tr>
          <tr>
            <th>本社所在地</th>
            <td>東京都港区南青山3丁目1番36号青山丸竹ビル6F</td>
          </tr>
        </tbody>
      </table>
      </div>
    </section>
  );
}
export { CompanyProfile };